"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blogPostUpdateSchema = exports.blogPostCreateSchema = exports.blogPostSchema = void 0;
const zod_1 = require("zod");
exports.blogPostSchema = zod_1.z.object({
    id: zod_1.z.number(),
    title: zod_1.z.string(),
    slug: zod_1.z.string(),
    contentHtml: zod_1.z.string(),
    imageUrl: zod_1.z.string().nullish(),
});
exports.blogPostCreateSchema = zod_1.z.object({
    title: zod_1.z.string().trim().min(1, "Title is required"),
    slug: zod_1.z.string().trim().optional(),
    contentHtml: zod_1.z.string(),
    imageUrl: zod_1.z.string().nullish(),
});
exports.blogPostUpdateSchema = exports.blogPostCreateSchema.partial();
